import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { jsx2uf3lx2x6pvok as jsx } from './jsx/runtime/jsx.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_BUILDER_CHILDREN() {
  _init_properties_ChildrenBuilder_kt__gexuom();
  return BUILDER_CHILDREN;
}
var BUILDER_CHILDREN;
function get_DEFAULT_KEY() {
  _init_properties_ChildrenBuilder_kt__gexuom();
  return DEFAULT_KEY;
}
var DEFAULT_KEY;
function setDefaultKey(builder, key) {
  _init_properties_ChildrenBuilder_kt__gexuom();
  // Inline function 'kotlin.js.asDynamic' call
  builder[get_DEFAULT_KEY()] = key;
}
function addChildNode(_this__u8e3s4, node) {
  _init_properties_ChildrenBuilder_kt__gexuom();
  // Inline function 'react.builderChildren' call
  // Inline function 'kotlin.js.asDynamic' call
  var children = _this__u8e3s4[get_BUILDER_CHILDREN()];
  if (!(children == null)) {
    children.push(node);
  } else {
    // Inline function 'react.ReactNodeArray' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'react.builderChildren' call
    var value = [node];
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4[get_BUILDER_CHILDREN()] = value;
  }
}
function addChild(_this__u8e3s4, type) {
  _init_properties_ChildrenBuilder_kt__gexuom();
  addChildElement(_this__u8e3s4, type, null, getDefaultKey(_this__u8e3s4));
}
function addChild_0(_this__u8e3s4, type, block) {
  _init_properties_ChildrenBuilder_kt__gexuom();
  var defaultKey = getDefaultKey(_this__u8e3s4);
  // Inline function 'js.objects.unsafeJso' call
  // Inline function 'js.objects.unsafeJso' call
  // Inline function 'kotlin.apply' call
  var this_0 = {};
  block(this_0);
  addChildElement(_this__u8e3s4, type, this_0, defaultKey);
}
function addChild_1(_this__u8e3s4, provider, value, block) {
  _init_properties_ChildrenBuilder_kt__gexuom();
  addChild_0(_this__u8e3s4, provider, ($this$addChild) => {
    $this$addChild.value = value;
    block($this$addChild);
    return Unit_instance;
  });
}
function addChildElement(_this__u8e3s4, type, props, defaultKey) {
  _init_properties_ChildrenBuilder_kt__gexuom();
  var element = jsx(type, props, defaultKey);
  addChildNode(_this__u8e3s4, element);
}
function getDefaultKey(_this__u8e3s4) {
  _init_properties_ChildrenBuilder_kt__gexuom();
  // Inline function 'kotlin.js.asDynamic' call
  var key = _this__u8e3s4[get_DEFAULT_KEY()];
  Reflect.deleteProperty(_this__u8e3s4, get_DEFAULT_KEY());
  return key;
}
function buildChildren(_this__u8e3s4) {
  _init_properties_ChildrenBuilder_kt__gexuom();
  return buildChildren_0(_this__u8e3s4);
}
function buildChildren_0(builder) {
  _init_properties_ChildrenBuilder_kt__gexuom();
  // Inline function 'kotlin.js.asDynamic' call
  var children = builder[get_BUILDER_CHILDREN()];
  Reflect.deleteProperty(builder, get_BUILDER_CHILDREN());
  return children;
}
var properties_initialized_ChildrenBuilder_kt_gby2z0;
function _init_properties_ChildrenBuilder_kt__gexuom() {
  if (!properties_initialized_ChildrenBuilder_kt_gby2z0) {
    properties_initialized_ChildrenBuilder_kt_gby2z0 = true;
    BUILDER_CHILDREN = Symbol('@@builder-children');
    DEFAULT_KEY = Symbol('@@default-key');
  }
}
//region block: exports
export {
  addChildNode as addChildNodeajp8y977cuss,
  addChild as addChild3ve192cpbfuql,
  addChild_0 as addChildspxcpid5g99g,
  addChild_1 as addChild1mvba2e12qyhq,
  buildChildren as buildChildren1tjqe2lljx0v,
  setDefaultKey as setDefaultKeyykye56baz645,
};
//endregion

//# sourceMappingURL=ChildrenBuilder.mjs.map
